import { render, staticRenderFns } from "./EditTariffValueWizard.vue?vue&type=template&id=b37913a0&scoped=true&"
import script from "./EditTariffValueWizard.vue?vue&type=script&lang=js&"
export * from "./EditTariffValueWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37913a0",
  null
  
)

export default component.exports